import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IMAGES } from "../../../../../assets/images";
import SignUp from "../../component/sign-up";
import SignIn from "../../component/sign-in";
import { routerPath } from "../../../../navigation/path";
import CustomButton from "../../../../components/button";
import { useDispatch, useSelector } from "react-redux";
import {
  login,
  setToken,
  setUser,
} from "../../../../../store/slices/userSlice";
import Mobile from "../../component/mobile";
import OTP from "../../component/otp";
import ForgotPassword from "../../component/forgot-password";
import {
  changePassword,
  loginUser,
  registerUser,
  sendOtp,
  verifyOtp,
} from "../../services";
import { toast } from "react-toastify";

const Login = () => {
  const [currentPage, setCorrentPage] = useState("signIn");
  const [isLoader, setLoader] = useState(false);
  const [pageProps, setPageProps] = useState({});

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const pageUpdated = (page) => {
    setCorrentPage(page);
  };

  const signInSubmit = async (value) => {
    console.log(value);
    let payload = {
      mobile_number: "",
      email: value.email,
      password: value.password,
      is_otp: 0,
      otp: "",
    };
    setLoader(true);
    try {
      const res = await loginUser(payload);
      setLoader(false);
      toast.success(res.message);
      dispatch(setUser({ ...res.data.user, token: res.data.token }));
      localStorage.setItem(
        "user",
        JSON.stringify({ ...res.data.user, token: res.data.token }),
      );
      // dispatch(setToken({ token: res.data.token }))
      if (res.data.user.is_membership == 1) {
        localStorage.setItem("token", JSON.stringify(res.data.token));
        dispatch(setToken({ token: res.data.token }));
        navigate(routerPath.home);
      } else {
        navigate(routerPath.purchasePlan);
      }
    } catch (err) {
      console.log(err);
      setLoader(false);
    }
  };

  const signUpSubmit = async (value) => {
    let payload = {
      name: value.fullName,
      email: value.email,
      mobile_number: value.phoneNumber,
      password: value.password,
    };
    console.log("signUpSubmit", payload);
    try {
      setLoader(true);
      const res = await registerUser(payload);
      toast.success(res.message);
      setPageProps({ ...payload, action: "register" });
      console.log(res);
      setLoader(false);
      setCorrentPage("otp");
    } catch (err) {
      console.log(err);
      setLoader(false);
      toast.error(err);
    }
  };

  const mobileSubmit = async (value) => {
    console.log("mobileSubmit", value);
    let parma = {
      mobile_number: value.phoneNumber,
      action: "login",
      password: "",
      is_otp: 1,
    };
    try {
      setLoader(true);
      const res = await sendOtp({ mobile_number: value.phoneNumber });
      setLoader(false);
      toast.success(res.message);
      setPageProps(parma);
      setCorrentPage("otp");
    } catch (err) {
      setLoader(false);
      toast.success(err);
    }
  };

  const otpSubmit = async (value) => {
    try {
      setLoader(true);
      let res = {};
      if (value.action == "login") {
        res = await loginUser(value);
      } else if (value.action == "register") {
        res = await verifyOtp(value);
      } else {
        res = await changePassword(value);
      }
      console.log(res);
      setLoader(false);
      toast.success(res.message);
      if (value.action == "forgot") {
        setCorrentPage("signIn");
      } else {
        dispatch(setUser({ ...res.data.user, token: res.data.token }));
        localStorage.setItem(
          "user",
          JSON.stringify({ ...res.data.user, token: res.data.token }),
        );
        if (res.data.user.is_membership == 1) {
          localStorage.setItem("token", JSON.stringify(res.data.token));
          dispatch(setToken({ token: res.data.token }));
        } else {
          navigate(routerPath.purchasePlan);
        }
      }
    } catch (err) {
      setLoader(false);
      console.log(err);
    }
  };

  const forgotpasswordSubmit = async (value) => {
    try {
      setLoader(true);
      const res = await sendOtp({ mobile_number: value.phoneNumber });
      setLoader(false);
      toast.success(res.message);
      setPageProps({
        ...value,
        mobile_number: value.phoneNumber,
        action: "forgot",
      });
      setCorrentPage("otp");
    } catch (err) {
      setLoader(false);
    }
  };

  return (
    <div className="min-h-screen w-screen">
      <div className="grid grid-cols-1 md:grid-cols-2 min-h-screen w-full">
        {/* Left Side */}
        <div className="hidden md:flex flex-col justify-center h-full">
          <img
            src={IMAGES.OnboardLeft}
            alt="Onboarding"
            className="w-full object-cover h-screen"
          />
        </div>

        {/* Right Side */}
        <div className="p-4 sm:p-6 md:p-8 flex flex-col justify-center bg-white min-h-screen overflow-y-auto">
          {currentPage === "signIn" ? (
            <SignIn
              onPageUpdate={pageUpdated}
              onFormSubmit={signInSubmit}
              isLoader={isLoader}
            />
          ) : currentPage === "signUp" ? (
            <SignUp
              onPageUpdate={pageUpdated}
              onFormSubmit={signUpSubmit}
              isLoader={isLoader}
            />
          ) : currentPage === "mobile" ? (
            <Mobile
              onPageUpdate={pageUpdated}
              onFormSubmit={mobileSubmit}
              isLoader={isLoader}
            />
          ) : currentPage === "otp" ? (
            <OTP
              onPageUpdate={pageUpdated}
              pageProps={pageProps}
              onFormSubmit={otpSubmit}
              isLoader={isLoader}
            />
          ) : (
            <ForgotPassword
              onPageUpdate={pageUpdated}
              onFormSubmit={forgotpasswordSubmit}
              isLoader={isLoader}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
